var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.0001,
    cy: 46.631,
    r: 46.631,
    fill: "#23A26D",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1681 24.4258C33.933 24.4258 23.9629 34.3959 23.9629 46.631C23.9629 58.8661 33.933 68.8362 46.1681 68.8362C58.4032 68.8362 68.3734 58.8661 68.3734 46.631C68.3734 34.3959 58.4032 24.4258 46.1681 24.4258ZM56.7822 41.5238L44.1919 54.1142C43.881 54.425 43.4591 54.6027 43.015 54.6027C42.5709 54.6027 42.149 54.425 41.8381 54.1142L35.554 47.8301C34.9101 47.1861 34.9101 46.1203 35.554 45.4763C36.198 44.8324 37.2638 44.8324 37.9078 45.4763L43.015 50.5835L54.4285 39.1701C55.0724 38.5261 56.1383 38.5261 56.7822 39.1701C57.4262 39.814 57.4262 40.8577 56.7822 41.5238Z",
    fill: "#23A26D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success Icon.5c77ef259dfcd3450df27ae8aab5a4bf.svg";
export { ForwardRef as ReactComponent };